import useSWR from 'swr'

const API_BASE = '/api/v1'

const fetcher = (url: string) => fetch(url).then(r => {
  if (!r.ok) throw new Error(`HTTP ${r.status}`)
  return r.json()
})

export function useStats() {
  return useSWR(`${API_BASE}/stats`, fetcher)
}

export function useLog() {
  return useSWR(`${API_BASE}/log`, fetcher, { refreshInterval: 30000 })
}

export function useCouncilMemos() {
  return useSWR(`${API_BASE}/log/council`, fetcher, { refreshInterval: 60000 })
}

export function useCouncilDirectives() {
  return useSWR(`${API_BASE}/log/council/directives`, fetcher, { refreshInterval: 60000 })
}
